exports.foo = () => {}
exports.bar = () => {}
exports.__esModule = true
